import React from "react";
import { isURL } from "class-validator";
import { useDCContext } from "@src/context/dcContext";
import { ImageWithRetry } from "@src/components/atoms";

/** eg. "You're helping LOGO make a difference" */
const HelpingLogoMakeADifference = ({ customer }) => {
  const { getDynamicReplacement } = useDCContext();

  const customerCode = customer.customerCode.toLowerCase();
  const logoUrl = getDynamicReplacement(`logos__${customerCode}`);

  const logoReplacement = isURL(logoUrl) ? (
    <ImageWithRetry
      className="w-32 block mx-auto my-2 md:inline-block md:mx-2 md:my-0"
      src={logoUrl}
      alt={customer.name}
    />
  ) : (
    customer.name
  );

  return (
    <div className="text-primary-500 mt-4">
      {/* TODO: Refactor? Dynamic content doesn't let a replacement be a node/element */}
      {getDynamicReplacement(
        "captain__impact__customer_alltime_caption",
        {
          CUSTOMER_LOGO: "{{customerLogo}}",
        },
        "You're helping {{customerLogo}} make a difference",
        true,
      )
        .split(/(\{\{customerLogo\}\})/)
        .map((part, i) => (
          <React.Fragment key={i}>
            {part === "{{customerLogo}}" ? logoReplacement : part}
          </React.Fragment>
        ))}
    </div>
  );
};

export default HelpingLogoMakeADifference;
